/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import { useMemo } from 'react'
import { UiSelectOption } from 'components/Ui/UiSelect'

/** Preset Anlasstyp values (German labels stored as values), grouped for the dropdown. */
const anlasstypGroups: { groupLabel: string; values: string[] }[] = [
    {
        groupLabel: 'Firmen & Organisationen',
        values: [
            'Teamevent',
            'Weihnachtsfeier',
            'Sommerfest',
            'Betriebsausflug',
            'Lehrlingsausflug',
            'Kundenevent',
            'Workshop / Seminar',
            'Jubiläumsanlass',
        ],
    },
    {
        groupLabel: 'Schulen & Bildung',
        values: ['Schulreise', 'Lehrerevent'],
    },
    {
        groupLabel: 'Vereine',
        values: ['Vereinsausflug'],
    },
    {
        groupLabel: 'Private Anlässe',
        values: [
            'Kindergeburtstag',
            'Erwachsenengeburtstag',
            'Polterabend',
            'Privater Ausflug',
        ],
    },
]

const defaultAnlasstypen = anlasstypGroups.flatMap((group) => group.values)

const useAnlasstypOptions = (otherLabel: string) => {
    return useMemo<{ groupLabel: string; options: UiSelectOption[] }[]>(() => {
        return [
            ...anlasstypGroups.map((group) => ({
                groupLabel: group.groupLabel,
                options: group.values.map((anlasstyp) => ({
                    value: anlasstyp,
                    label: anlasstyp,
                })),
            })),
            {
                groupLabel: '',
                options: [{ value: 'custom', label: otherLabel }],
            },
        ]
    }, [otherLabel])
}

export default useAnlasstypOptions
export { defaultAnlasstypen, anlasstypGroups }
